module.exports = __webpack_public_path__ + "images/territory_1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/territory_1.jpg
// module id = 55
// module chunks = 0